// extracted by mini-css-extract-plugin
export default {"nav_button":"Navigation_nav_button__KDUXe","nav_bar":"Navigation_nav_bar__UqGXq","linktag":"Navigation_linktag__6DW-m"};